import { render } from "./DemoAppointmentsView.vue?vue&type=template&id=5fb87e36&scoped=true"
import script from "./DemoAppointmentsView.vue?vue&type=script&lang=js"
export * from "./DemoAppointmentsView.vue?vue&type=script&lang=js"

import "./DemoAppointmentsView.vue?vue&type=style&index=0&id=5fb87e36&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fb87e36"]])

export default __exports__